import React from "react";
import PropTypes from "prop-types";
import { Common } from "../../utils/common";

function TotalCount({ count, title, subtitle, color, isDuration = false }) {
  return (
    <div className="count-widget btn-non-clickable">
      <h4 className="count-widget-title">{title}</h4>
      <div className="count-widget-content">
        <div className="count-widget-column">
          <div className={`count-widget-total ${color}-total`}>
            {isDuration ? count : Common.formatNumberWithCommas(count)}
          </div>
          <div className="count-widget-subtitle">{subtitle}</div>
        </div>
      </div>
      <div className={`count-widget-underline ${color}-underline`} />
    </div>
  );
}

TotalCount.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  isDuration: PropTypes.bool,
};

export default TotalCount;
